<template>
  <li class="slot-wrap">
    <section :id="domId" ref="ad" />
  </li>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref, toRefs } from 'vue';
import { useGlobalState } from '@cpc/comment-sdk-core-comment';
import { constant } from '@cpc/comment-sdk-common';

export default defineComponent({
  name: 'AdSlot',

  props: {
    id: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'new',
    },
    index: {
      type: Number,
      default: 0,
    },
    listSize: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    loadStatus: {
      type: Number,
      default: -1,
    },
  },

  setup(props) {
    const { slotCallback } = toRefs(useGlobalState());
    const ad = ref(null);

    const domId = computed(() => `slot-${props.type}-${props.id}`);

    // loadCompleted 每一刷最后一条返回true，提供给业务一次渲染时机，期间符合规则的配置需要业务自行缓存
    // -- 最后一页
    // -- 非最后一页
    onMounted(() => {
      const params = {
        el: ad.value,
        index: props.index,
        size: props.listSize,
        total: props.total,
        type: props.type,
        domId: domId.value,
        loadCompleted:
          (props.loadStatus === constant.LoadStatus.LOADCOMPLETED
            || props.loadStatus === constant.LoadStatus.DEFAULT)
          && props.index === props.listSize,
      };

      console.log('adSlot call', JSON.stringify(params));

      slotCallback.value(params);
    });

    return {
      ad,
      domId,
    };
  },
});
</script>

<style lang="scss" scoped></style>
